import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import ActionAdd from '../../store/action/Keygroup/Add'
import ActionEdit from '../../store/action/Keygroup/Edit'
import {IsEdit, IsCreate, IsView } from '../../store/constants'

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        'group-id':'',
        'group-name' : '',
        'keywords': ''
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleChange(field, value) {
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    this.setState({ form:formVal })
  }
  async handleSubmit(dispatch) {

    const form = this.state.form;
    if(form.get('group-name') === '' || form.get('keywords') === ''){
        this.setState({error : "Name & Keywords cannot be empty!"});
    }else{

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        case IsEdit:
            await this.SubmitEditData();
          break;
        default:
          // code block
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'data' : 
            {
                'group-name': form.get('group-name'),
                'keywords': form.get('keywords'),
            }
        };

        var response = await this.props.actionAdd(data);
        if(response.ok){
          toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  async SubmitEditData(){
    const form = this.state.form;
    var data = 
        {
          'data' : {
                'group-id': form.get('group-id'),
                'group-name': form.get('group-name'),
                'keywords': form.get('keywords'),
            }
        };

        var response = await this.props.actionEdit(data);
        if(response.ok){
          toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
        this.setState({
          form:  fromJS({
            'group-id': this.props.item.get('group-id'),
            'group-name': this.props.item.get('group-name'),
            'keywords': this.props.item.get('keywords'),
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })  
      }
    }
  }

  render(){
    const { form, errors, disabled } = this.state;
    return (
      <div className="card no-margin-bottom">
      <div className="body">
        <div className="row no-margin-bottom">
              <span className="col-sm-2">Name</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'group-name'}
                      value={ form.get('group-name')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="name"
                      disabled={ disabled }
                      hasError={errors.has('group-name')}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Keywords</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'keywords'}
                      value={ form.get('keywords')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="keywords"
                      disabled={ disabled }
                      hasError={errors.has('keywords')}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
            <button type="button"
                  className="btn btn-wide btn-danger"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Cancel
              </button>
              <button type="button"
                  className="btn btn-wide btn-success"
                  onClick={ this.handleSubmit }>
                    Submit
              </button>
            </div>
          </div>
        </div>
        </div>
    );
  }
}


export default connect(
  (state) => {
      return {
          Users: state.user.users,
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionEdit: ActionEdit,
  }, dispatch),
)(Form);